import posthog from 'posthog-js';

export function trackEvent(name: string, params?: Record<string, string>) {
  const eventParams = { page: window.location.pathname, ...params };
  window.gtag?.('event', name, eventParams);
  posthog.capture(name, eventParams);
}
